import findLastIndex from 'lodash/findLastIndex';
import { useEffect, useState } from 'react';
const instancesStack = [];

const updateActiveInstance = () => {
    instancesStack.forEach((instance, idx) => {
        instance.setModalIndex(idx);
        instance.setIsTopModal(idx === instancesStack.length - 1);
    });
};

// Adds an instance to the stack with either a custom or random id
const addInstance = instance => {
    instancesStack.push(instance);
    updateActiveInstance();
};

// Remove an instance from the stack
const removeInstance = removedInstanceId => {
    // Find the last (most recent) added instance with the id to remove.
    // Usually this should just be the last element unless another modal
    // popped up after the user clicked to close one but before closing
    // that modal was fully resolved
    const indexToRemove = findLastIndex(
        instancesStack,
        instance => instance.id === removedInstanceId
    );
    instancesStack.splice(indexToRemove, 1);
    updateActiveInstance();
};

const useModalManager = isManaged => {
    // Modal isn't active until it gets onto the instance stack on mount
    const [modalIndex, setModalIndex] = useState(0);
    const [isTopModal, setIsTopModal] = useState(false);

    useEffect(() => {
        const id = Math.random();
        addInstance({ id, setModalIndex, setIsTopModal });

        return () => removeInstance(id);
    }, [setModalIndex]);

    if (!isManaged) {
        return {
            contentZIndex: 12,
            hideOverlay: false,
            overlayZIndex: 11,
        };
    }

    return {
        contentZIndex: 12 + 2 * modalIndex,
        hideOverlay: !isTopModal,
        overlayZIndex: 11 + 2 * modalIndex,
    };
};

export default useModalManager;
